import { IUserAd } from "./../../models/IUserAd";

export class UserAdState {
  userAds: IUserAd[] = [];
}
